import React from 'react';
import { PrimaryButton, SelectInput} from '../BasicForm';
import SelectFieldOptions from '../../utils/selectFieldOptions';

export const VisitorRelationshipForm = (props) => (
	<fieldset>
		<div className="legend-container">
			<legend className="body-bold">{props.fullName}</legend>
		</div>
		<PrimaryButton 
			className="link-style"
			options={props.id}
			label="Remove"
			handleClick={props.handleRemoveOffender} />
		<SelectInput
			className={props.className}
			options={SelectFieldOptions.relationshipTypes}
			value={props.value} 
			name={props.id}
			required={true}
			label="Your Relationship to Inmate"
			hint = "For example, if you are the inmate's father, select &#34father&#34 from the dropdown list."
			onChange={props.handleInputChange}
			errMessage={props.errMessage} />
	</fieldset>
)


// WEBPACK FOOTER //
// ./src/components/VisitorRelationshipForm/VisitorRelationshipForm.js